"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../declarations/window");
/**
 * The Unity Context.
 */
var UnityContext = /** @class */ (function () {
    /**
     * Creates a new instance of the Unity context model.
     * @param {IUnityConfig} unityConfig The Unity config used to build the player.
     */
    function UnityContext(unityConfig) {
        this.unityConfig = unityConfig;
        /**
         * A list of the UnityEvents binded to this unityContext.
         * @type {IUnityEvent[]}
         */
        this.unityEvents = [];
        if (typeof window.ReactUnityWebGL === "undefined")
            window.ReactUnityWebGL = {};
    }
    /**
     * Sets the reference to the UnityComponent.
     * @param {UnityComponent} unityComponentReference the target unity component.
     */
    UnityContext.prototype.setComponentReference = function (unityComponentReference) {
        this.unityComponentReference = unityComponentReference;
    };
    /**
     * Sets the reference of the UnityInstance.
     * @param {UnityInstance} unityInstance the target unityInstance.
     */
    UnityContext.prototype.setUnityInstance = function (unityInstance) {
        this.unityInstance = unityInstance;
    };
    /**
     * Quits the Unity Instance and clears it from memory.
     */
    UnityContext.prototype.quitUnityInstance = function () {
        var _this = this;
        if (typeof this.unityInstance !== "undefined")
            this.unityInstance.Quit().then(function () {
                _this.invokeEventListener("quitted");
                _this.unityInstance = undefined;
            });
    };
    /**
     * Sends a message to the UnityInstance to invoke a public method.
     * @param {string} gameObjectName the name of the game object in your Unity scene.
     * @param {string} methodName the name of the public method on the game object.
     * @param {string | number | boolean} parameter an optional method parameter.
     */
    UnityContext.prototype.send = function (gameObjectName, methodName, parameter) {
        if (typeof this.unityInstance !== "undefined")
            if (typeof parameter === "undefined")
                this.unityInstance.SendMessage(gameObjectName, methodName);
            else
                this.unityInstance.SendMessage(gameObjectName, methodName, parameter);
    };
    /**
     * Registers an event listener for the Unity player. These can be
     * system events like when the player is initialized or loader and
     * your custom events from Unity.
     * @param {string} eventName the event name
     * @param {Function} eventListener the event function
     * @returns {any} The Function
     */
    UnityContext.prototype.on = function (eventName, eventListener) {
        this.unityEvents.push({ eventName: eventName, eventCallback: eventListener });
        window.ReactUnityWebGL[eventName] = function (parameter) {
            return eventListener(parameter);
        };
    };
    /**
     * Invokes an event listener that has been registered using the on function.
     * @param {string} eventName the event name
     * @param {Function} eventValue the event value
     */
    UnityContext.prototype.invokeEventListener = function (eventName, eventValue) {
        for (var _i = 0, _a = this.unityEvents; _i < _a.length; _i++) {
            var _unityEvent = _a[_i];
            if (_unityEvent.eventName === eventName)
                _unityEvent.eventCallback(eventValue);
        }
    };
    /**
     * Enables or disabled the fullscreen mode of the UnityInstance.
     * @param {boolean} enabled
     */
    UnityContext.prototype.setFullscreen = function (enabled) {
        if (typeof this.unityInstance !== "undefined")
            this.unityInstance.SetFullscreen(enabled === true ? 1 : 0);
    };
    return UnityContext;
}());
exports.default = UnityContext;
//# sourceMappingURL=unityContext.js.map